export enum DemandDefinitionReferencePeriodFormat {
    DATE = 'DATE',
    MONTH = 'MONTH',
    SHORT_MONTH = 'SHORT_MONTH',
}
